import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: ReactNode;
  className?: string;
  id?: string;
  alternate?: boolean;
}
export function Section({
  children,
  className = '',
  id,
  alternate = false
}: SectionProps) {
  return <section id={id} className={`
        py-16 md:py-24 px-6 md:px-8
        ${alternate ? 'bg-cream-dark' : 'bg-cream'}
        ${className}
      `} data-id="element-124">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className="max-w-2xl mx-auto" data-id="element-125">
        {children}
      </motion.div>
    </section>;
}